/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WhatsNewRouteImport } from './routes/whats-new'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OfflineRouteImport } from './routes/offline'
import { Route as LicensesRouteImport } from './routes/licenses'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PatternEditorIndexRouteImport } from './routes/pattern-editor/index'
import { Route as IconHandoffIndexRouteImport } from './routes/icon-handoff/index'
import { Route as GridEditorIndexRouteImport } from './routes/grid-editor/index'
import { Route as CrochetIndexRouteImport } from './routes/crochet/index'
import { Route as CrochetIconsIndexRouteImport } from './routes/crochet-icons/index'
import { Route as WaitlistSplatRouteImport } from './routes/waitlist.$'
import { Route as TryKnitRouteImport } from './routes/try/knit'
import { Route as TryCrochetRouteImport } from './routes/try/crochet'
import { Route as SignUpSplatRouteImport } from './routes/sign-up.$'
import { Route as SignInSplatRouteImport } from './routes/sign-in.$'
import { Route as SharedShareIdRouteImport } from './routes/shared.$shareId'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as PatternEditorPatternIdRouteImport } from './routes/pattern-editor/$patternId'
import { Route as GridEditorDiagramIdRouteImport } from './routes/grid-editor/$diagramId'
import { Route as CrochetDiagramIdRouteImport } from './routes/crochet/$diagramId'
import { Route as GridEditorDiagramIdViewRouteImport } from './routes/grid-editor/$diagramId_.view'
import { Route as EmbedDiagramDiagramIdRouteImport } from './routes/embed/diagram.$diagramId'
import { Route as CrochetDiagramIdViewRouteImport } from './routes/crochet/$diagramId_.view'

const WhatsNewRoute = WhatsNewRouteImport.update({
  id: '/whats-new',
  path: '/whats-new',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const OfflineRoute = OfflineRouteImport.update({
  id: '/offline',
  path: '/offline',
  getParentRoute: () => rootRouteImport,
} as any)
const LicensesRoute = LicensesRouteImport.update({
  id: '/licenses',
  path: '/licenses',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PatternEditorIndexRoute = PatternEditorIndexRouteImport.update({
  id: '/pattern-editor/',
  path: '/pattern-editor/',
  getParentRoute: () => rootRouteImport,
} as any)
const IconHandoffIndexRoute = IconHandoffIndexRouteImport.update({
  id: '/icon-handoff/',
  path: '/icon-handoff/',
  getParentRoute: () => rootRouteImport,
} as any)
const GridEditorIndexRoute = GridEditorIndexRouteImport.update({
  id: '/grid-editor/',
  path: '/grid-editor/',
  getParentRoute: () => rootRouteImport,
} as any)
const CrochetIndexRoute = CrochetIndexRouteImport.update({
  id: '/crochet/',
  path: '/crochet/',
  getParentRoute: () => rootRouteImport,
} as any)
const CrochetIconsIndexRoute = CrochetIconsIndexRouteImport.update({
  id: '/crochet-icons/',
  path: '/crochet-icons/',
  getParentRoute: () => rootRouteImport,
} as any)
const WaitlistSplatRoute = WaitlistSplatRouteImport.update({
  id: '/waitlist/$',
  path: '/waitlist/$',
  getParentRoute: () => rootRouteImport,
} as any)
const TryKnitRoute = TryKnitRouteImport.update({
  id: '/try/knit',
  path: '/try/knit',
  getParentRoute: () => rootRouteImport,
} as any)
const TryCrochetRoute = TryCrochetRouteImport.update({
  id: '/try/crochet',
  path: '/try/crochet',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpSplatRoute = SignUpSplatRouteImport.update({
  id: '/sign-up/$',
  path: '/sign-up/$',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInSplatRoute = SignInSplatRouteImport.update({
  id: '/sign-in/$',
  path: '/sign-in/$',
  getParentRoute: () => rootRouteImport,
} as any)
const SharedShareIdRoute = SharedShareIdRouteImport.update({
  id: '/shared/$shareId',
  path: '/shared/$shareId',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PatternEditorPatternIdRoute = PatternEditorPatternIdRouteImport.update({
  id: '/pattern-editor/$patternId',
  path: '/pattern-editor/$patternId',
  getParentRoute: () => rootRouteImport,
} as any)
const GridEditorDiagramIdRoute = GridEditorDiagramIdRouteImport.update({
  id: '/grid-editor/$diagramId',
  path: '/grid-editor/$diagramId',
  getParentRoute: () => rootRouteImport,
} as any)
const CrochetDiagramIdRoute = CrochetDiagramIdRouteImport.update({
  id: '/crochet/$diagramId',
  path: '/crochet/$diagramId',
  getParentRoute: () => rootRouteImport,
} as any)
const GridEditorDiagramIdViewRoute = GridEditorDiagramIdViewRouteImport.update({
  id: '/grid-editor/$diagramId_/view',
  path: '/grid-editor/$diagramId/view',
  getParentRoute: () => rootRouteImport,
} as any)
const EmbedDiagramDiagramIdRoute = EmbedDiagramDiagramIdRouteImport.update({
  id: '/embed/diagram/$diagramId',
  path: '/embed/diagram/$diagramId',
  getParentRoute: () => rootRouteImport,
} as any)
const CrochetDiagramIdViewRoute = CrochetDiagramIdViewRouteImport.update({
  id: '/crochet/$diagramId_/view',
  path: '/crochet/$diagramId/view',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/licenses': typeof LicensesRoute
  '/offline': typeof OfflineRoute
  '/privacy': typeof PrivacyRoute
  '/settings': typeof SettingsRoute
  '/terms': typeof TermsRoute
  '/whats-new': typeof WhatsNewRoute
  '/crochet/$diagramId': typeof CrochetDiagramIdRoute
  '/grid-editor/$diagramId': typeof GridEditorDiagramIdRoute
  '/pattern-editor/$patternId': typeof PatternEditorPatternIdRoute
  '/s/$token': typeof STokenRoute
  '/shared/$shareId': typeof SharedShareIdRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/sign-up/$': typeof SignUpSplatRoute
  '/try/crochet': typeof TryCrochetRoute
  '/try/knit': typeof TryKnitRoute
  '/waitlist/$': typeof WaitlistSplatRoute
  '/crochet-icons/': typeof CrochetIconsIndexRoute
  '/crochet/': typeof CrochetIndexRoute
  '/grid-editor/': typeof GridEditorIndexRoute
  '/icon-handoff/': typeof IconHandoffIndexRoute
  '/pattern-editor/': typeof PatternEditorIndexRoute
  '/crochet/$diagramId/view': typeof CrochetDiagramIdViewRoute
  '/embed/diagram/$diagramId': typeof EmbedDiagramDiagramIdRoute
  '/grid-editor/$diagramId/view': typeof GridEditorDiagramIdViewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/licenses': typeof LicensesRoute
  '/offline': typeof OfflineRoute
  '/privacy': typeof PrivacyRoute
  '/settings': typeof SettingsRoute
  '/terms': typeof TermsRoute
  '/whats-new': typeof WhatsNewRoute
  '/crochet/$diagramId': typeof CrochetDiagramIdRoute
  '/grid-editor/$diagramId': typeof GridEditorDiagramIdRoute
  '/pattern-editor/$patternId': typeof PatternEditorPatternIdRoute
  '/s/$token': typeof STokenRoute
  '/shared/$shareId': typeof SharedShareIdRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/sign-up/$': typeof SignUpSplatRoute
  '/try/crochet': typeof TryCrochetRoute
  '/try/knit': typeof TryKnitRoute
  '/waitlist/$': typeof WaitlistSplatRoute
  '/crochet-icons': typeof CrochetIconsIndexRoute
  '/crochet': typeof CrochetIndexRoute
  '/grid-editor': typeof GridEditorIndexRoute
  '/icon-handoff': typeof IconHandoffIndexRoute
  '/pattern-editor': typeof PatternEditorIndexRoute
  '/crochet/$diagramId/view': typeof CrochetDiagramIdViewRoute
  '/embed/diagram/$diagramId': typeof EmbedDiagramDiagramIdRoute
  '/grid-editor/$diagramId/view': typeof GridEditorDiagramIdViewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/licenses': typeof LicensesRoute
  '/offline': typeof OfflineRoute
  '/privacy': typeof PrivacyRoute
  '/settings': typeof SettingsRoute
  '/terms': typeof TermsRoute
  '/whats-new': typeof WhatsNewRoute
  '/crochet/$diagramId': typeof CrochetDiagramIdRoute
  '/grid-editor/$diagramId': typeof GridEditorDiagramIdRoute
  '/pattern-editor/$patternId': typeof PatternEditorPatternIdRoute
  '/s/$token': typeof STokenRoute
  '/shared/$shareId': typeof SharedShareIdRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/sign-up/$': typeof SignUpSplatRoute
  '/try/crochet': typeof TryCrochetRoute
  '/try/knit': typeof TryKnitRoute
  '/waitlist/$': typeof WaitlistSplatRoute
  '/crochet-icons/': typeof CrochetIconsIndexRoute
  '/crochet/': typeof CrochetIndexRoute
  '/grid-editor/': typeof GridEditorIndexRoute
  '/icon-handoff/': typeof IconHandoffIndexRoute
  '/pattern-editor/': typeof PatternEditorIndexRoute
  '/crochet/$diagramId_/view': typeof CrochetDiagramIdViewRoute
  '/embed/diagram/$diagramId': typeof EmbedDiagramDiagramIdRoute
  '/grid-editor/$diagramId_/view': typeof GridEditorDiagramIdViewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/licenses'
    | '/offline'
    | '/privacy'
    | '/settings'
    | '/terms'
    | '/whats-new'
    | '/crochet/$diagramId'
    | '/grid-editor/$diagramId'
    | '/pattern-editor/$patternId'
    | '/s/$token'
    | '/shared/$shareId'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/try/crochet'
    | '/try/knit'
    | '/waitlist/$'
    | '/crochet-icons/'
    | '/crochet/'
    | '/grid-editor/'
    | '/icon-handoff/'
    | '/pattern-editor/'
    | '/crochet/$diagramId/view'
    | '/embed/diagram/$diagramId'
    | '/grid-editor/$diagramId/view'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/licenses'
    | '/offline'
    | '/privacy'
    | '/settings'
    | '/terms'
    | '/whats-new'
    | '/crochet/$diagramId'
    | '/grid-editor/$diagramId'
    | '/pattern-editor/$patternId'
    | '/s/$token'
    | '/shared/$shareId'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/try/crochet'
    | '/try/knit'
    | '/waitlist/$'
    | '/crochet-icons'
    | '/crochet'
    | '/grid-editor'
    | '/icon-handoff'
    | '/pattern-editor'
    | '/crochet/$diagramId/view'
    | '/embed/diagram/$diagramId'
    | '/grid-editor/$diagramId/view'
  id:
    | '__root__'
    | '/'
    | '/licenses'
    | '/offline'
    | '/privacy'
    | '/settings'
    | '/terms'
    | '/whats-new'
    | '/crochet/$diagramId'
    | '/grid-editor/$diagramId'
    | '/pattern-editor/$patternId'
    | '/s/$token'
    | '/shared/$shareId'
    | '/sign-in/$'
    | '/sign-up/$'
    | '/try/crochet'
    | '/try/knit'
    | '/waitlist/$'
    | '/crochet-icons/'
    | '/crochet/'
    | '/grid-editor/'
    | '/icon-handoff/'
    | '/pattern-editor/'
    | '/crochet/$diagramId_/view'
    | '/embed/diagram/$diagramId'
    | '/grid-editor/$diagramId_/view'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LicensesRoute: typeof LicensesRoute
  OfflineRoute: typeof OfflineRoute
  PrivacyRoute: typeof PrivacyRoute
  SettingsRoute: typeof SettingsRoute
  TermsRoute: typeof TermsRoute
  WhatsNewRoute: typeof WhatsNewRoute
  CrochetDiagramIdRoute: typeof CrochetDiagramIdRoute
  GridEditorDiagramIdRoute: typeof GridEditorDiagramIdRoute
  PatternEditorPatternIdRoute: typeof PatternEditorPatternIdRoute
  STokenRoute: typeof STokenRoute
  SharedShareIdRoute: typeof SharedShareIdRoute
  SignInSplatRoute: typeof SignInSplatRoute
  SignUpSplatRoute: typeof SignUpSplatRoute
  TryCrochetRoute: typeof TryCrochetRoute
  TryKnitRoute: typeof TryKnitRoute
  WaitlistSplatRoute: typeof WaitlistSplatRoute
  CrochetIconsIndexRoute: typeof CrochetIconsIndexRoute
  CrochetIndexRoute: typeof CrochetIndexRoute
  GridEditorIndexRoute: typeof GridEditorIndexRoute
  IconHandoffIndexRoute: typeof IconHandoffIndexRoute
  PatternEditorIndexRoute: typeof PatternEditorIndexRoute
  CrochetDiagramIdViewRoute: typeof CrochetDiagramIdViewRoute
  EmbedDiagramDiagramIdRoute: typeof EmbedDiagramDiagramIdRoute
  GridEditorDiagramIdViewRoute: typeof GridEditorDiagramIdViewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/whats-new': {
      id: '/whats-new'
      path: '/whats-new'
      fullPath: '/whats-new'
      preLoaderRoute: typeof WhatsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offline': {
      id: '/offline'
      path: '/offline'
      fullPath: '/offline'
      preLoaderRoute: typeof OfflineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/licenses': {
      id: '/licenses'
      path: '/licenses'
      fullPath: '/licenses'
      preLoaderRoute: typeof LicensesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pattern-editor/': {
      id: '/pattern-editor/'
      path: '/pattern-editor'
      fullPath: '/pattern-editor/'
      preLoaderRoute: typeof PatternEditorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/icon-handoff/': {
      id: '/icon-handoff/'
      path: '/icon-handoff'
      fullPath: '/icon-handoff/'
      preLoaderRoute: typeof IconHandoffIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grid-editor/': {
      id: '/grid-editor/'
      path: '/grid-editor'
      fullPath: '/grid-editor/'
      preLoaderRoute: typeof GridEditorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crochet/': {
      id: '/crochet/'
      path: '/crochet'
      fullPath: '/crochet/'
      preLoaderRoute: typeof CrochetIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crochet-icons/': {
      id: '/crochet-icons/'
      path: '/crochet-icons'
      fullPath: '/crochet-icons/'
      preLoaderRoute: typeof CrochetIconsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/waitlist/$': {
      id: '/waitlist/$'
      path: '/waitlist/$'
      fullPath: '/waitlist/$'
      preLoaderRoute: typeof WaitlistSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/try/knit': {
      id: '/try/knit'
      path: '/try/knit'
      fullPath: '/try/knit'
      preLoaderRoute: typeof TryKnitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/try/crochet': {
      id: '/try/crochet'
      path: '/try/crochet'
      fullPath: '/try/crochet'
      preLoaderRoute: typeof TryCrochetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up/$': {
      id: '/sign-up/$'
      path: '/sign-up/$'
      fullPath: '/sign-up/$'
      preLoaderRoute: typeof SignUpSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/$': {
      id: '/sign-in/$'
      path: '/sign-in/$'
      fullPath: '/sign-in/$'
      preLoaderRoute: typeof SignInSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shared/$shareId': {
      id: '/shared/$shareId'
      path: '/shared/$shareId'
      fullPath: '/shared/$shareId'
      preLoaderRoute: typeof SharedShareIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pattern-editor/$patternId': {
      id: '/pattern-editor/$patternId'
      path: '/pattern-editor/$patternId'
      fullPath: '/pattern-editor/$patternId'
      preLoaderRoute: typeof PatternEditorPatternIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grid-editor/$diagramId': {
      id: '/grid-editor/$diagramId'
      path: '/grid-editor/$diagramId'
      fullPath: '/grid-editor/$diagramId'
      preLoaderRoute: typeof GridEditorDiagramIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crochet/$diagramId': {
      id: '/crochet/$diagramId'
      path: '/crochet/$diagramId'
      fullPath: '/crochet/$diagramId'
      preLoaderRoute: typeof CrochetDiagramIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grid-editor/$diagramId_/view': {
      id: '/grid-editor/$diagramId_/view'
      path: '/grid-editor/$diagramId/view'
      fullPath: '/grid-editor/$diagramId/view'
      preLoaderRoute: typeof GridEditorDiagramIdViewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embed/diagram/$diagramId': {
      id: '/embed/diagram/$diagramId'
      path: '/embed/diagram/$diagramId'
      fullPath: '/embed/diagram/$diagramId'
      preLoaderRoute: typeof EmbedDiagramDiagramIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crochet/$diagramId_/view': {
      id: '/crochet/$diagramId_/view'
      path: '/crochet/$diagramId/view'
      fullPath: '/crochet/$diagramId/view'
      preLoaderRoute: typeof CrochetDiagramIdViewRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LicensesRoute: LicensesRoute,
  OfflineRoute: OfflineRoute,
  PrivacyRoute: PrivacyRoute,
  SettingsRoute: SettingsRoute,
  TermsRoute: TermsRoute,
  WhatsNewRoute: WhatsNewRoute,
  CrochetDiagramIdRoute: CrochetDiagramIdRoute,
  GridEditorDiagramIdRoute: GridEditorDiagramIdRoute,
  PatternEditorPatternIdRoute: PatternEditorPatternIdRoute,
  STokenRoute: STokenRoute,
  SharedShareIdRoute: SharedShareIdRoute,
  SignInSplatRoute: SignInSplatRoute,
  SignUpSplatRoute: SignUpSplatRoute,
  TryCrochetRoute: TryCrochetRoute,
  TryKnitRoute: TryKnitRoute,
  WaitlistSplatRoute: WaitlistSplatRoute,
  CrochetIconsIndexRoute: CrochetIconsIndexRoute,
  CrochetIndexRoute: CrochetIndexRoute,
  GridEditorIndexRoute: GridEditorIndexRoute,
  IconHandoffIndexRoute: IconHandoffIndexRoute,
  PatternEditorIndexRoute: PatternEditorIndexRoute,
  CrochetDiagramIdViewRoute: CrochetDiagramIdViewRoute,
  EmbedDiagramDiagramIdRoute: EmbedDiagramDiagramIdRoute,
  GridEditorDiagramIdViewRoute: GridEditorDiagramIdViewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
